import React, { Component } from 'react';

import IconTick from '../icons/IconTick';
import IconError from '../icons/IconError';

import Flash from './Flash';

class Callout extends Component {
  render() {
    const { showCallout, hideCallout } = this.props;

    const icon = !showCallout || showCallout.isError ? <IconError src="error" /> : <IconTick src="tick" />;

    const message = (
      <span>
        <strong className="t-emphasis-text">{showCallout && showCallout.title}</strong>
        <span className="flash__text t-body-small">{showCallout && showCallout.details}</span>
      </span>
    );

    return (
      <Flash
        isVisible={!!showCallout}
        icon={icon}
        message={message}
        onDismiss={hideCallout}
        flashType={showCallout && showCallout.isError ? 'error' : 'default'}
        autoDismiss
      />
    );
  }
}

export default Callout;
